import React from 'react';
import GitHubButton from 'react-github-btn';

const GithubButton = () => (
  <>
    <GitHubButton>Tanishq Gautam</GitHubButton>
  </>
);

export default GithubButton;
